const clinicDoctorInfo = {
    namespaced: true,
    state : {
        clinicDoctorId : '',
        loginId : '',
        clinicDoctorClass : '',
        doctorNm : '',
        doctorGender : '',
        doctorBirthYear : '',
        doctorBirthMonth : '',
        doctorBirthDay : '',
        doctorPostNo : '',
        doctorAddr : '',
        doctorAddrDtl : '',
        doctorPhoneNum : '',
        doctorTelNum : '',
        doctorEmail : '',
        doctorLicenseNum : '',
        licenseIssuanceDate : '',
        doctorEmailRecvYn : '',
        doctorPhoneRecvYn : '',
        clinicNm : '',
        clinicBusinessNum : '',
        clinicPostNo : '',
        clinicAddr : '',
        clinicAddrDtl : '',
        clinicTelNum : '',
        clinicFaxNum : '',
        clinicOfficialNm : '',
        clinicOfficialPosition : '',
        approvalYn : '',
        nick_nm : ''
    },
    getters: {
        getClinicDoctorId (state) {
            return state.clinicDoctorId
        },
        getLoginId (state) {
            return state.loginId
        },
        getClinicDoctorClass (state) {
            return state.clinicDoctorClass
        },
        getDoctorNm (state) {
            return state.doctorNm
        },
        getDoctorGender (state) {
            return state.doctorGender
        },
        getDoctorBirthYear (state) {
            return state.doctorBirthYear
        },
        getDoctorBirthMonth (state) {
            return state.doctorBirthMonth
        },
        getDoctorBirthDay (state) {
            return state.doctorBirthDay
        },
        getDoctorPostNo (state) {
            return state.doctorPostNo
        },
        getDoctorAddr (state) {
            return state.doctorAddr
        },
        getDoctorAddrDtl (state) {
            return state.doctorAddrDtl
        },
        getDoctorPhoneNum (state) {
            return state.doctorPhoneNum
        },
        getdoctorTelNum (state) {
            return state.doctorTelNum
        },
        getDoctorEmail (state) {
            return state.doctorEmail
        },
        getDoctorLicenseNum (state) {
            return state.doctorLicenseNum
        },
        getLicenseIssuanceDate (state) {
            return state.licenseIssuanceDate
        },
        getDoctorEmailRecvYn (state) {
            return state.doctorEmailRecvYn
        },
        getDoctorPhoneRecvYn (state) {
            return state.doctorPhoneRecvYn
        },
        getClinicNm (state) {
            return state.clinicNm
        },
        getClinicBusinessNum (state) {
            return state.clinicBusinessNum
        },
        getClinicPostNo (state) {
            return state.clinicPostNo
        },
        getClinicAddr (state) {
            return state.clinicAddr
        },
        getClinicAddrDtl (state) {
            return state.clinicAddrDtl
        },
        getClinicTelNum (state) {
            return state.clinicTelNum
        },
        getClinicFaxNum (state) {
            return state.clinicFaxNum
        },
        getClinicOfficialNm (state) {
            return state.clinicOfficialNm
        },
        getClinicOfficialPosition (state) {
            return state.clinicOfficialPosition
        },
        getApprovalYn (state) {
            return state.approvalYn
        },
        getNickNm (state) {
            return state.nick_nm
        }
    },
    mutations: {
        setClinicDoctorId (state, payload) {
            state.clinicDoctorId = payload
        },
        setLoginId (state, payload) {
            state.loginId = payload
        },
        setClinicDoctorClass (state, payload) {
            state.clinicDoctorClass = payload
        },
        setDoctorNm (state, payload) {
            state.doctorNm = payload
        },
        setDoctorGender (state, payload) {
            state.doctorGender = payload
        },
        setDoctorBirthYear (state, payload) {
            state.doctorBirthYear = payload
        },
        setDoctorBirthMonth (state, payload) {
            state.doctorBirthMonth = payload
        },
        setDoctorBirthDay (state, payload) {
            state.doctorBirthDay = payload
        },
        setDoctorPostNo (state, payload) {
            state.doctorPostNo = payload 
        },
        setDoctorAddr (state, payload) {
            state.doctorAddr = payload
        },
        setDoctorAddrDtl (state, payload) {
            state.doctorAddrDtl = payload
        },
        setDoctorPhoneNum (state, payload) {
            state.doctorPhoneNum = payload
        },
        setdoctorTelNum (state, payload) {
            state.doctorTelNum = payload
        },
        setDoctorEmail (state, payload) {
            state.doctorEmail = payload
        },
        setDoctorLicenseNum (state, payload) {
            state.doctorLicenseNum = payload
        },
        setLicenseIssuanceDate (state, payload) {
            state.licenseIssuanceDate = payload
        },
        setDoctorEmailRecvYn (state, payload) {
            state.doctorEmailRecvYn = payload
        },
        setDoctorPhoneRecvYn (state, payload) {
            state.doctorPhoneRecvYn = payload
        },
        setClinicNm (state, payload) {
            state.clinicNm = payload
        },
        setClinicPostNo (state, payload) {
            state.clinicPostNo = payload
        },
        setClinicBusinessNum (state, payload) {
            state.clinicBusinessNum = payload
        },
        setClinicAddr (state, payload) {
            state.clinicAddr = payload
        },
        setClinicAddrDtl (state, payload) {
            state.clinicAddrDtl = payload
        },
        setClinicTelNum (state, payload) {
            state.clinicTelNum = payload
        },
        setClinicFaxNum (state, payload) {
            state.clinicFaxNum = payload
        },
        setClinicOfficialNm (state, payload) {
            state.clinicOfficialNm = payload
        },
        setClinicOfficialPosition (state, payload) {
            state.clinicOfficialPosition = payload
        },
        setApprovalYn (state, payload) {
            state.approvalYn = payload
        },
        setNickNm (state, payload) {
            state.nick_nm = payload
        }
    },
    actions: {
        setClinicDoctorId ({commit}, payload) {
            commit('setClinicDoctorId', payload)
        },setLoginId ({commit}, payload) {
            commit('setLoginId', payload)
        },
        setClinicDoctorClass ({commit}, payload) {
            commit('setClinicDoctorClass', payload)
        },
        setDoctorNm ({commit}, payload) {
            commit('setDoctorNm', payload)
        },
        setDoctorGender ({commit}, payload) {
            commit('setDoctorGender', payload)
        },
        setDoctorBirthYear ({commit}, payload) {
            commit('setDoctorBirthYear', payload)
        },
        setDoctorBirthMonth ({commit}, payload) {
            commit('setDoctorBirthMonth', payload)
        },
        setDoctorBirthDay ({commit}, payload) {
            commit('setDoctorBirthDay', payload)
        },
        setDoctorPostNo ({commit}, payload) {
            commit('setDoctorPostNo', payload)
        },
        setDoctorAddr ({commit}, payload) {
            commit('setDoctorAddr', payload)
        },
        setDoctorAddrDtl ({commit}, payload) {
            commit('setDoctorAddrDtl', payload)
        },
        setDoctorPhoneNum ({commit}, payload) {
            commit('setDoctorPhoneNum', payload)
        },
        setdoctorTelNum ({commit}, payload) {
            commit('setdoctorTelNum', payload)
        },
        setDoctorEmail ({commit}, payload) {
            commit('setDoctorEmail', payload)
        },
        setDoctorLicenseNum ({commit}, payload) {
            commit('setDoctorLicenseNum', payload)
        },
        setLicenseIssuanceDate ({commit}, payload) {
            commit('setLicenseIssuanceDate', payload)
        },
        setDoctorEmailRecvYn ({commit}, payload) {
            commit('setDoctorEmailRecvYn', payload)
        },
        setDoctorPhoneRecvYn ({commit}, payload) {
            commit('setDoctorPhoneRecvYn', payload)
        },
        setClinicNm ({commit}, payload) {
            commit('setClinicNm', payload)
        },
        setClinicBusinessNum ({commit}, payload) {
            commit('setClinicBusinessNum', payload)
        },
        
        setClinicPostNo ({commit}, payload) {
            commit('setClinicPostNo', payload)
        },
        setClinicAddr ({commit}, payload) {
            commit('setClinicAddr', payload)
        },
        setClinicAddrDtl ({commit}, payload) {
            commit('setClinicAddrDtl', payload)
        },
        setClinicTelNum ({commit}, payload) {
            commit('setClinicTelNum', payload)
        },
        setClinicFaxNum ({commit}, payload) {
            commit('setClinicFaxNum', payload)
        },
        setClinicOfficialNm ({commit}, payload) {
            commit('setClinicOfficialNm', payload)
        },
        setClinicOfficialPosition ({commit}, payload) {
            commit('setClinicOfficialPosition', payload)
        },
        setApprovalYn ({commit}, payload) {
            commit('setApprovalYn', payload)
        },
        setNickNm ({commit}, payload) {
            commit('setNickNm', payload)
        },
        
        setClinicDoctorInfoInit ({commit}) {
            commit('setClinicDoctorId', '');
            commit('setLoginId', '');
            commit('setClinicDoctorClass', '');
            commit('setDoctorNm', '');
            commit('setDoctorGender', '');
            commit('setDoctorBirthYear', '');
            commit('setDoctorBirthMonth', '');
            commit('setDoctorBirthDay', '');
            commit('setDoctorPostNo', '');
            commit('setDoctorAddr', '');
            commit('setDoctorAddrDtl', '');
            commit('setDoctorPhoneNum', '');
            commit('setdoctorTelNum', '');
            commit('setDoctorEmail', '');
            commit('setDoctorLicenseNum', '');
            commit('setLicenseIssuanceDate', '');
            commit('setDoctorEmailRecvYn', '');
            commit('setDoctorPhoneRecvYn', '');
            commit('setClinicNm', '');
            commit('setClinicBusinessNum', '');
            commit('setClinicPostNo', '');
            commit('setClinicAddr', '');
            commit('setClinicAddrDtl', '');
            commit('setClinicTelNum', '');
            commit('setClinicFaxNum', '');
            commit('setClinicOfficialNm', '');
            commit('setClinicOfficialPosition', '');
            commit('setApprovalYn', '');
            commit('setNickNm', '');

        }
    }
}

export default clinicDoctorInfo